import React, { useEffect, useState } from "react";
import axios from "axios";
import {  Button, Checkbox } from "antd";
import { PageHeader } from '@ant-design/pro-layout';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import "moment-timezone";
import QRCode from "qrcode";
import DependenciesComponent from "../../components/DependenciesComponent";
import {useAxios} from "../../hooks/hooks";

function CocPage(props) {
  const axios = useAxios();
  const [coc, setCoc] = useState({});
  const [cocView, setCocView] = useState({});
  const [samples, setSamples] = useState([]);
  const [typepreservatives, setTypepreservatives] = useState([]);
  const [samplesLength, setSamplesLength] = useState([]);
  const [qr, setQR] = useState(null);

  const getCoc = async (id_coc) => {
    try {
      const response = await axios.current.get("/coc/" + id_coc);
      return response.data[0] || {};
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  const getCocView = async (id_coc) => {
    try {
      const response = await axios.current.get("/coc-views/" + id_coc);
      return response.data[0] || {};
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  const getSamples = async (id_coc) => {
    try {
      const response = await axios.current.get(
        "/samples/?page=1&page_size=100&filter[id_coc]=" + id_coc
      );
      return response.data.rows;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  const getTypepreservatives = async () => {
    try {
      const response = await axios.current.get(
        "/typepreservatives-list/?page=1&page_size=100"
      );
      return response.data.rows;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  useEffect(() => {
    var id_coc = props.id_coc || props.match.params.id;
    Promise.all([
      getCoc(id_coc),
      getCocView(id_coc),
      getSamples(id_coc),
      getTypepreservatives(id_coc),
      QRCode.toDataURL("https://ade.willingweb.app/dashboard/coc/" + id_coc),
    ]).then((v) => {
      var c = v[0];
      var cv = v[1];
      var s = v[2];
      s.sort(function (a, b) {
        return a.label_sample.localeCompare(b.label_sample, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      });
      var t = v[3];
      var qr = v[4];
      setCoc(c);
      setCocView(cv);
      setTypepreservatives(t);
      setSamples(s);
      setSamplesLength(s.length + 3);
      setQR(qr);
    });
  }, [props]);

  if (!cocView) {
    return <></>;
  }
  return (
    <DependenciesComponent
      mode="block"
      dependencies={["coc-views", "samples", "typepreservatives-list"]}
      {...props}
    >
      <PageHeader
        title="COC Document"
        style={{ padding: 0, paddingBottom: 16 }}
        extra={[
          <Button
            key="button"
            onClick={(e) => {
              window.print();
            }}
          >
            <FontAwesomeIcon icon="print" className="fa-fw" />
            &nbsp; Print
          </Button>,
        ]}
      />
      <table className="doc-table">
        <tbody>
          <tr>
            <td style={{ border: "none" }}>
              <h2 style={{ textTransform: "uppercase" }}>
                Chain of Custody Record
              </h2>
              <p>
                Email all invoices to <b>accounts@ade.group</b>
              </p>
            </td>
            <td style={{ border: "none", textAlign: "right" }}>
              <img alt="QR Code" src={qr} height={64} />
            </td>
          </tr>
        </tbody>
      </table>
      <h4>General Information</h4>
      <table className="doc-table">
        <tbody>
          <tr>
            <th width="18%">Company:</th>
            <td width="16%">ADE Consulting Group</td>
            <th width="19%">Office:</th>
            <td width="16%">{cocView.city_company}</td>
            <th width="15%">Method of Delivery:</th>
            <td width="16%">{cocView.name_delivery}</td>
          </tr>
          <tr>
            <th>Project Name:</th>
            <td>{cocView.place_project}</td>
            <th>Project/Job Number:</th>
            <td>{cocView.xero_project}</td>
          </tr>
          <tr>
            <td colSpan="2" style={{ borderLeftWidth: 0 }}></td>
            <th>Sample TAT:</th>
            <td>{coc.due_date_coc}</td>
            <th>Booking/Name,M:</th>
            <td>{cocView.booking_coc}</td>
          </tr>
          <tr>
            <th>Sampler:</th>
            <td>
              {cocView.first_name_consultant}&nbsp;
              {cocView.last_name_consultant}
            </td>
            <th>Contact Number:</th>
            <td>{cocView.phone_consultant}</td>
            <th>Email:</th>
            <td>{cocView.email_consultant}</td>
          </tr>
          <tr>
            <th>Project Manager:</th>
            <td>
              {cocView.first_name_project_manager}&nbsp;
              {cocView.last_name_project_manager}
            </td>
            <th>Contact Number:</th>
            <td>{cocView.phone_project_manager}</td>
            <th>Email:</th>
            <td>{cocView.email_project_manager}</td>
          </tr>
          <tr>
            <th>
              Required Turn Around Time
              <br />
              (Specify Date of Reporting):
            </th>
            <td>{cocView.turnaround_days_coc}&nbsp;Days</td>
            <th>After test storage:</th>
            <td>{cocView.name_storage}</td>
            <th>Sample disposal:</th>
            <td>{Math.ceil(cocView.disposal_days_coc / 7)}&nbsp;Weeks</td>
          </tr>
        </tbody>
      </table>
      <h4>Laboratory Use Only</h4>
      <table className="doc-table">
        <tbody>
          <tr>
            <th width="18%">Received By:</th>
            <td width="16%">
              {cocView.first_name_lab_officer}&nbsp;
              {cocView.last_name_lab_officer}
            </td>
            <th width="19%">Signature:</th>
            <td width="16%">&nbsp;</td>
            <th width="15%">Laboratory:</th>
            <td width="16%">{cocView.city_lab_company}</td>
          </tr>
          <tr>
            <th>Date:</th>
            <td>
              {moment(cocView.submit_date_coc).format("DD/MM/YYYY hh:mm")}
            </td>
            <th>Temperature Upon Receipt (˚C):</th>
            <td>
              {cocView.temperature_coc === null
                ? "Not Applicable"
                : cocView.temperature_coc}
            </td>
            <th>Workorder Number:</th>
            <td>{cocView.workorder_coc}</td>
          </tr>
          <tr>
            <th>Comments:</th>
            <td colSpan={5}>{cocView.comments_coc}</td>
          </tr>
        </tbody>
      </table>
      <h4>Samples</h4>
      <table className="doc-table-grid">
        <tbody>
          <tr>
            <th
              rowSpan={2}
              colSpan={3}
              style={{ textAlign: "center", borderRightWidth: 1 }}
            >
              Sample Data
            </th>
            <th
              rowSpan={2}
              colSpan={2}
              style={{ textAlign: "center", borderRightWidth: 1 }}
            >
              Container Data
            </th>
            <th
              colSpan={2}
              style={{ textAlign: "center", borderRightWidth: 1 }}
            >
              Analyses Required
            </th>
            <th
              rowSpan={3}
              style={{ textAlign: "center", borderRightWidth: 1 }}
            >
              Sample Comments
            </th>
            <th rowSpan={samplesLength} style={{ textAlign: "center" }}>
              Dangerous Goods/Hazard Warning
              <br />
              <div style={{ width: "100%", padding: 5, textAlign: "left" }}>
                <Checkbox />
                &nbsp;No known contamination
                <br />
                <Checkbox />
                &nbsp;Asbestos
                <br />
                <Checkbox />
                &nbsp;Heavy Metals
                <br />
                <Checkbox />
                &nbsp;Hydrocarbons
                <br />
                <Checkbox />
                &nbsp;Other:__________________
              </div>
            </th>
          </tr>
          <tr>
            <td rowSpan={2} style={{ textAlign: "center", padding: 5 }}>
              <span
                style={{
                  textOrientation: "mixed",
                  writingMode: "vertical-lr",
                  transform: "rotate(180deg)",
                }}
              >
                Asbestos/SMF
              </span>
            </td>
            <td rowSpan={2} style={{ textAlign: "center", padding: 5 }}>
              <span
                style={{
                  textOrientation: "mixed",
                  writingMode: "vertical-lr",
                  transform: "rotate(180deg)",
                }}
              >
                Lead
              </span>
            </td>
          </tr>
          <tr>
            <th style={{ textAlign: "center" }}>Sample ID</th>
            <th style={{ textAlign: "center" }}>Sample Date</th>
            <th style={{ borderRightWidth: 1, textAlign: "center" }}>Matrix</th>
            <th style={{ textAlign: "center" }}>Type &amp; Preservative</th>
            <th style={{ borderRightWidth: 1, textAlign: "center" }}>Number</th>
          </tr>
          {samples.map((s, i) => (
            <tr key={i}>
              <td>{s.label_sample}</td>
              <td>{moment(s.date_sample).format("DD/MM/YYYY hh:mm")}</td>
              <td>{s.matrix_id_matrix}</td>
              <td>{s.typepreservative_id_typepreservative}</td>
              <td>{s.label_sample}</td>
              <th style={{ textAlign: "center" }}>
                {s.id_analysis === 1 ? "X" : ""}
              </th>
              <th style={{ textAlign: "center" }}>
                {s.id_analysis === 2 ? "X" : ""}
              </th>
              <th style={{ textAlign: "center" }}>{s.comments_sample}</th>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="coc-copyright">
        &copy;Copyright ADE, Uncontrolled if printed
      </p>
    </DependenciesComponent>
  );
}

export default CocPage;
